module.exports = __webpack_public_path__ + "img/logo-black.8b089d30.svg";